var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wg-text",class:{
        ['wg-color__' + _vm.realColor]: _vm.realColor,
        ['wg-bg-color__' + _vm.finalBackgroundColor]: _vm.finalBackgroundColor,
        [_vm.realFontWeight]: _vm.realFontWeight,
        'wg-text__clamp': _vm.lineClamp,
        'wg-flex__shrink': +_vm.realStyle.flexShrink === 0,
    },style:(Object.assign(_vm.extraStyle, {
        fontSize: _vm.realFontSize,
        lineHeight: _vm.realLineHeight,
        margin: _vm.finalMargin,
        padding: _vm.finalPadding,
        borderRadius: _vm.finalBorderRadius ? _vm.finalBorderRadius : '',
        backgroundColor: _vm.customBackgroundColor,
        color: _vm.customColor,
        '-webkit-line-clamp': _vm.lineClamp
    }))},[_vm._t("prefix"),_c('span',[_vm._v(_vm._s(_vm.renderText))]),(_vm.arrow)?_c('span',{staticClass:"wg-arrow"},[_vm._v(_vm._s(_vm.arrow))]):_vm._e(),_vm._t("suffix")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }